import { MenuItem } from '@material-ui/core';
import cx from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import resolveHelpCenterUrl from '../../utils/resolveHelpCenterUrl';
import useStyles from './HelpCenterExternalLink.styles';

interface Props {
  to: string
  children: React.ReactNode
  component?: React.ElementType
  className?: string
  dataCy?: string
}

const HelpCenterExternalLink: React.FC<Props> = ({ to, component, children, className, dataCy }) => {
  const classes = useStyles();

  const LinkItem = component ?? MenuItem;

  return (
    <LinkItem
      component={!component ? Link : undefined}
      to={resolveHelpCenterUrl(to)}
      target="_blank"
      rel="noopener noreferrer"
      className={cx(classes.root, className)}
      data-cy={dataCy}
    >
      {children}
    </LinkItem>
  );
};

export default HelpCenterExternalLink;
